<template>
  <div v-if="props.TotalData > 0" class="d-flex overflow-auto h-48px">
    <select
      v-model="pageSize"
      class="form-select form-select-sm"
      style="width: 70px"
      @change="pageSizeUp"
    >
      <option selected="true" value="10">10</option>
      <option value="25">25</option>
      <option value="50">50</option>
      <option value="100">100</option>
    </select>
    <ul class="pagination pagination-outline ms-5 flex-nowrap">
      <li
        id="prev-1"
        :class="`page-item previous m-0 me-1 mt-1 mb-1 ${
          step === 1 ? 'disabled' : ''
        }`"
      >
        <a class="page-link" @click="pageButton(false)"
          ><i class="previous"></i
        ></a>
      </li>
      <li
        v-for="number in ac"
        :key="number"
        :class="`page-item m-1 ${number === '...' ? 'disabled' : ''} ${
          number === step ? 'active' : ''
        }`"
        :id="`step-${number}`"
      >
        <a class="page-link" @click="pageButton(number)">{{ number }}</a>
      </li>

      <li
        id="prev-2"
        :class="`page-item next m-0 ms-1 mt-1 mb-1 ${
          step === sayfaSayisi ? 'disabled' : ''
        }`"
      >
        <a class="page-link active" @click="pageButton(true)">
          <span class="next"></span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup>
import {
  computed,
  ref,
  defineEmits,
  defineProps,
  watch,
  onDeactivated,
} from "vue";

const props = defineProps({ TotalData: Number });

watch(
  () => props.TotalData,
  (newValue, oldValue) => {
    sayfaSayisi.value = Math.ceil(newValue / pageSize.value);
    pagemethod();
  }
);

const emit = defineEmits(["onPage"]);

const pageSize = ref(10);
let pagestep = ref([]);
const ac = computed(() => pagestep.value);
const step = ref(1);
let sayfaSayisi = ref(0);

const pagemethod = () => {
  sayfaSayisi.value = Math.ceil(props.TotalData / pageSize.value);
  pagestep.value = [];

  for (var i = 1; i <= sayfaSayisi.value; i++) {
    if (i <= 5 && step.value < 5) {
      pagestep.value.push(i);
    } else if (
      i > sayfaSayisi.value - 5 &&
      step.value > sayfaSayisi.value - 4
    ) {
      pagestep.value.push(i);
    } else {
      if (i == 1) {
        pagestep.value.push(i);
        pagestep.value.push("...");
      }
      if (i == sayfaSayisi.value) {
        pagestep.value.push("...");
        pagestep.value.push(i);
      }
      if (i == step.value - 1 || i == step.value || i == step.value + 1) {
        pagestep.value.push(i);
      }
    }
  }
};

const pageSizeUp = () => {
  step.value = 1;
  sayfaSayisi.value = Math.ceil(props.TotalData / pageSize.value);
  pagemethod();
  emit("onPage", { step, pageSize });
};

const pageButton = (deger) => {
  if (deger === false) {
    step.value--;
  } else if (deger === true) {
    step.value++;
  } else {
    step.value = deger;
  }
  pagemethod();
  emit("onPage", { step, pageSize });
};

pagemethod();
</script>

<style scoped>
li a {
  cursor: pointer;
}
li a span {
  cursor: pointer;
}
</style>
